/* eslint-disable max-len */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import PropTypes from 'prop-types';

const ImageFile = ({ title, ...other }) => (
  <SvgIcon
    style={{
      width: '16px',
      height: '19px',
    }}
    viewBox="0 0 22 27"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...other}
  >
    <title>{title}</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-47.000000, -146.000000)" fillRule="nonzero">
        <g transform="translate(47.000000, 146.000000)">
          <path
            d="M15.3282,0 L1.7439,0 C0.91188,0 0.23454,0.675 0.23454,1.50936 L0.23454,25.49076 C0.23454,26.32395 0.91071,27.00012 1.7439,27.00012 L19.8552,27.00012 C20.68956,27.00012 21.36456,26.32395 21.36456,25.49076 L21.36456,6.03756 L15.3282,0 Z M15.3282,2.13399 L19.2318,6.03759 L15.3282,6.03759 L15.3282,2.13399 Z"
            id="Shape"
            fill="#00B7C1"
          />
          <path
            d="M19.85646,25.49049 L1.7439,25.49049 L1.7439,1.50909 L13.8189,1.50909 L13.8189,6.03729 C13.8189,6.87048 14.4939,7.54665 15.32826,7.54665 L19.85646,7.54665 L19.85646,25.49049 Z"
            id="Path"
            fill="#E6F8F9"
          />
          <path
            d="M8.78110667,12.7999558 C9.39420098,12.7999558 9.8913825,13.3196053 9.8913825,13.9606987 C9.8913825,14.6017922 9.39420098,15.1214417 8.78110667,15.1214417 C8.16801235,15.1214417 7.67083083,14.6017922 7.67083083,13.9606987 C7.67083083,13.3196053 8.16801235,12.7999558 8.78110667,12.7999558 Z M8.78110667,14.5410702 C9.08785569,14.5410702 9.33624458,14.2812455 9.33624458,13.9606987 C9.33624458,13.640152 9.08785569,13.3803273 8.78110667,13.3803273 C8.47435764,13.3803273 8.22596875,13.640152 8.22596875,13.9606987 C8.22596875,14.2812455 8.47435764,14.5410702 8.78110667,14.5410702 Z M14.4712703,11.084075 C14.785115,11.084075 15.039025,11.337985 15.039025,11.6518297 L15.039025,19.6003953 C15.039025,19.91424 14.785115,20.16815 14.4712703,20.16815 L6.52270469,20.16815 C6.20885999,20.16815 5.95495,19.91424 5.95495,19.6003953 L5.95495,11.6518297 C5.95495,11.337985 6.20885999,11.084075 6.52270469,11.084075 L14.4712703,11.084075 Z M6.52822469,19.3164675 C6.52822469,19.3953223 6.58048454,19.4662942 6.66500113,19.5175485 C6.58112869,19.4662932 6.52822469,19.3953274 6.52822469,19.3164675 Z M14.4713107,19.3164675 L14.4713107,18.4644418 L12.4017162,16.3948877 C12.2909207,16.2840922 12.1111368,16.2840922 12.0003414,16.3948877 C12.0003414,16.3948877 10.6333899,17.7618391 10.3313949,18.0638341 C10.0297733,18.3654557 9.82633043,18.3611155 9.52865539,18.0638341 C9.23137398,17.7661591 8.99519813,17.5303769 8.99519813,17.5303769 C8.88440269,17.4195814 8.70461876,17.4195814 8.59382332,17.5303769 L6.60632864,19.5175687 C6.65758402,19.5688241 6.72854983,19.600366 6.8066224,19.600366 L14.1874333,19.600366 C14.3443557,19.600366 14.4713107,19.473411 14.4713107,19.3164887 L14.4713107,19.3164675 Z M14.4712703,17.661349 L14.4712703,11.9356566 C14.4712703,11.7787342 14.3443153,11.6517792 14.187393,11.6517792 L6.80658203,11.6517792 C6.64965968,11.6517792 6.52270469,11.7787342 6.52270469,11.9356566 L6.52270469,18.7987762 L8.39311573,16.9283651 C8.61469651,16.7063907 8.97427447,16.7063907 9.19585525,16.9283651 L9.92998982,17.6624997 L11.7995934,15.7928961 C12.0211742,15.5709217 12.3807521,15.5709217 12.6023329,15.7928961 L14.4712703,17.661349 Z"
            id="Shape"
            stroke="#00B7C1"
            strokeWidth="0.5"
            fill="#00B7C1"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

ImageFile.propTypes = {
  title: PropTypes.string,
};

ImageFile.defaultProps = {
  title: '',
};

export default ImageFile;
